'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdFormatListNumbered = function MdFormatListNumbered(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm11.6 21.6v-3.2h23.4v3.2h-23.4z m0 10v-3.2h23.4v3.2h-23.4z m0-23.2h23.4v3.2h-23.4v-3.2z m-8.2 10v-1.8h5v1.6l-3.1 3.4h3.1v1.8h-5v-1.6l2.9-3.4h-2.9z m1.6-5v-5h-1.6v-1.8h3.2v6.8h-1.6z m-1.6 15v-1.8h5v6.8h-5v-1.8h3.2v-0.7h-1.6v-1.8h1.6v-0.7h-3.2z' })
        )
    );
};

exports.default = MdFormatListNumbered;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/format-list-numbered.js
// module id = 1045
// module chunks = 36573943044255 79611799117203 213534597649335